import Styles from './Source15.scss';

import Template from './Source15.hbs';
import Button from 'views/components/button/Button.svelte'
import Hedy from 'views/components/taskGroups/tasks/template38/hedy/Hedy'

export default class Source15 extends BaseView {

    // List of languages that we support
    // Each language needs an import statement so that Rspack knows which ones to include
    static languages = {
        css: {
            label: 'CSS',
            load: () => import(
                /* rspackChunkName: "highlightjs-css" */
                '@highlightjs/cdn-assets/es/languages/css.min'
            ),
        },
        hedy: {
            label: 'Hedy',
            load: null
        },
        xml: {
            label: 'HTML / XML',
            load: () => import(
                /* rspackChunkName: "highlightjs-xml" */
                '@highlightjs/cdn-assets/es/languages/xml.min'
            ),
        },
        java: {
            label: 'Java',
            load: () => import(
                /* rspackChunkName: "highlightjs-java" */
                '@highlightjs/cdn-assets/es/languages/java.min'
            ),
        },
        javascript: {
            label: 'Javascript',
            load: () => import(
                /* rspackChunkName: "highlightjs-javascript" */
                '@highlightjs/cdn-assets/es/languages/javascript.min'
            ),
        },
        lua: {
            label: 'Lua',
            load: () => import(
                /* rspackChunkName: "highlightjs-lua" */
                '@highlightjs/cdn-assets/es/languages/lua.min'
            ),
        },
        php: {
            label: 'PHP',
            load: () => import(
                /* rspackChunkName: "highlightjs-php" */
                '@highlightjs/cdn-assets/es/languages/php.min'
            ),
        },
        python: {
            label: 'Python',
            load: () => import(
                /* rspackChunkName: "highlightjs-python" */
                '@highlightjs/cdn-assets/es/languages/python.min'
            ),
        },
        sql: {
            label: 'SQL',
            load: () => import(
                /* rspackChunkName: "highlightjs-sql" */
                '@highlightjs/cdn-assets/es/languages/sql.min'
            ),
        },
        plaintext: {
            label: 'Text',
            load: () => import(
                /* rspackChunkName: "highlightjs-plaintext" */
                '@highlightjs/cdn-assets/es/languages/plaintext.min'
            ),
        },
    };

    initialize() {

        const isHedy = this.model.get('source').language === 'hedy'

        this.setElement(Template({
            Styles,
            title: this.model.get('title'),
            isHedy
        }))

        if (isHedy) {
            this.renderHedyViewer()
        } else {
            this.renderDefaultViewer()
        }
    }

    async renderDefaultViewer() {
        const value = this.model.get('source').language
        const entry = Source15.languages[value]
        const hasLineNumbers = this.model.get('source').lineNumbers ?? false

        let hljs
        try {
            ({ default: hljs } = await import(
                /* rspackChunkName: "highlightjs-core" */
                '@highlightjs/cdn-assets/es/core.min'
            ))
            await import(
                /* rspackChunkName: "highlightjs-styles" */
                '@highlightjs/cdn-assets/styles/github-dark-dimmed.min.css'
            )
            const { default: grammar } = await entry.load()
            hljs.registerLanguage(value, grammar)

            // The line numbers plugin needs window.hljs to work
            if (hasLineNumbers) {
                window.hljs = hljs
                await import(
                    /* rspackChunkName: "highlightjs-line-numbers" */
                    'highlightjs-line-numbers.js'
                )
                delete window.hljs
            }
        } catch {
            const errorButton = this.addSvelteChildView(this.$('.js-container'), Button, {
                icon: 'refresh',
                label: window.i18n.gettext('Loading failed. Try again'),
                inline: true,
                callback: () => {
                    this.unregisterAndDestroyChildView(errorButton)
                    this.renderDefaultViewer()
                }
            })
            return
        }

        let highlightedHTML = hljs.highlight(
            this.model.get('source').code,
            {
                language: value
            }
        ).value
        if (hasLineNumbers) {
            highlightedHTML = hljs.lineNumbersValue(highlightedHTML)
        }

        this.$('.js-code').attr('data-language', entry.label)
        this.$('.js-code').html(highlightedHTML)
    }

    renderHedyViewer() {
        this.addChildView(new Hedy({
            level: this.model.get('source').hedyLevel,
            program: this.model.get('source').code,
            showRun: false,
            readOnly: true
        }), '.js-hedy')
    }
}
